export enum RequestCmd {
  Burn = 0x20,
  Recover = 0x21,
  Reboot = 0x22,
  EnterUpdate = 0x50,
  WriteFW = 0x51,
  FinishUpdate = 0x52,
  BurnResult = 0x54,
  UpdateState = 0x55,
  CheckAuth = 0x56,
  GetDeviceInfo = 0x66,

  Log = 0xbf,

  EnterFlashUpdate = 0xa1,
  WriteFlash = 0xa2,
  FinishFlashUpdate = 0xa3,
  EnterUpdate2505 = 0xa4,
  Send2505Data = 0xa5,
  Request2505Result = 0xa6,
  Get2505UpdateState = 0xa7,
}

export enum FeatureId {
  host = 0x01,
  c2 = 0x02,
  c3 = 0x03,
  c4 = 0x04,
  hdmi1 = 0x11,
  hdmi2 = 0x12,
  dp = 0x13,
  ufp = 0x14,
  hostdriver = 0x15,
  eth = 0x21,
  errorInfo = 0x31,
}

export const MID: Record<string, string> = {
  '00001': 'A',
  '00010': 'B',
  '00011': 'C',
  '00100': 'D',
  '00101': 'E',
  '00110': 'F',
  '00111': 'G',
  '01000': 'H',
  '01001': 'I',
  '01010': 'J',
  '01011': 'K',
  '01100': 'L',
  '01101': 'M',
  '01110': 'N',
  '01111': 'O',
  '10000': 'P',
  '10001': 'Q',
  '10010': 'R',
  '10011': 'S',
  '10100': 'T',
  '10101': 'U',
  '10110': 'V',
  '10111': 'W',
  '11000': 'X',
  '11001': 'Y',
  '11010': 'Z',
}

export interface BaseRequest {
  requestCmd: RequestCmd
  fid?: FeatureId
  data: Uint8Array
}

export interface BaseResponse {
  packetCountdown: number
  cmd: RequestCmd
  fid?: FeatureId
  data: Uint8Array
}

export function errorCodeToString(errorCode: number): string {
  switch (errorCode) {
    case 0:
      return 'No Error'
    case 1:
      return 'Busy'
    case 2:
      return 'Package Checksum not Match'
    case 3:
      return 'File CRC32 Not Match'
    case 4:
      return 'File system error can not update'
    case 5:
      return 'Not Support command while Debug mode'
    case 6:
      return 'Not Support command while USB update mode'
    case 7:
      return 'Checksum Error'
    case 9:
      return 'report ID not supported'
    case 0x0a:
      return 'packet length is out of range'
    case 8:
      return 'Firmware Update not Start'
    case 0x10:
      return '已经正在进行固件升级'
    case 0x11:
      return '网络异常'
    case 0x12:
      return '后台错误'
    default:
      return 'Unknow error code ' + errorCode
  }
}
